module.exports = __webpack_public_path__ + "img/listpackage.6562c41a.svg";